import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function EmptyCell({ className }: { className?: string }) {
	const { t } = useTranslation();
	return (
		<span className={cn("text-muted-foreground italic", className)}>
			{t("common.none")}
		</span>
	);
}
